import { LoginData, Theme } from "../types/common";

export const yleTunnusSDKExists = () => window.yleTunnus !== undefined;

export const initializeYleTunnus = async (
  language: string,
  theme: Theme
): Promise<YleTunnus | undefined> => {
  if (yleTunnusSDKExists()) {
    const apiKeys = __API_KEYS.split("&");
    const appId = apiKeys[0].split("=")[1];
    const appKey = apiKeys[1].split("=")[1];

    return window.yleTunnus({
      environment: __YLE_TUNNUS_SDK_ENV,
      initiatingApp: appKey,
      language: language === "swe" ? "sv" : "fi",
      returnToUrl: window.location.href,
      theme: theme === "light" ? "light" : "dark",
      trackingAppName: appId
    });
  }
};

type YleTunnusChannelMessage =
  | {
      type: string;
      state: "loggedIn";
      user: UserInfo;
    }
  | {
      type: string;
      state: "loggedOut";
      user: UserInfo | null;
    };

export const createTunnusSdkBroadcastChannel = (
  onLoginDataChange: (loginData: LoginData) => void
) => {
  const tunnusChangesChannel = new BroadcastChannel("yle-tunnus");
  tunnusChangesChannel.onmessage = event => {
    const message = event?.data as YleTunnusChannelMessage;
    if (message?.type === "state") {
      const loggedIn = message?.state === "loggedIn" && !!message?.user;
      onLoginDataChange({
        loggedIn,
        residenceInFinland: loggedIn
          ? !!message.user?.residenceInFinland
          : false,
        userId: loggedIn ? message.user.userId : undefined
      });
    }
  };
  tunnusChangesChannel.postMessage({ type: "request-state" });

  return tunnusChangesChannel;
};
